<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-08 11:16:35
 * @FilePath: 
 * @Description: 团购
-->
<template>
  <div class="group_page_container">
    <shopping-list :vpnId="vpnId" ref="listRef" id="listRef"></shopping-list>
    <myFooter></myFooter>
  </div>
</template>

<script>
import shoppingList from "@/views/ShoppingList/index2.vue";
import myFooter from "@/components/myFooter";
import { mapState } from "vuex";
export default {
  name: "GroupMall",
  components: {
    shoppingList,
    myFooter,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      vpnId: (rootState) => rootState.vpnId,
    }),
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.group_page_container {
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  min-height: calc(100vh - 100px - env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
}
</style>
